// Local imports
import { main } from './lib.js';

main();
